import { Accordion, CustomButton } from '@ui-kit'
import { NAMESPACES } from '../../utils/patient-adherence.strings'
import { SvgChart5, SvgChart3 } from '../../../assets/svg-components/'
import PatientInformationSidePanel from './SidePanel'

const UpdatedAdherence = ({
  setSelectedTabIndex,
}: {
  setSelectedTabIndex: React.Dispatch<React.SetStateAction<number>>
}) => {
  const patientData = [
    { label: 'Name', value: 'Bill Martin' },
    { label: 'Date of Birth', value: '03/10/1962' },
    {
      label: 'Address',
      value: '1234 Main St, Apt 7700, Sedona, Arkansas - 86336',
    },
  ]
  const drugData = [
    { label: 'Drug Name', value: 'Tecfidera' },
    { label: 'Drug NDC', value: '64406-0007-03' },
    {
      label: 'Drug Indication',
      value: 'Relapsing forms of Multiple Sclerosis',
    },
    { label: 'Dosage Form', value: 'Injectable' },
    { label: 'ICD10', value: 'G35: Multiple Sclerosis' },
  ]
  return (
    <div className="flex gap-2 p-4">
      <div className="flex flex-col gap-4 font-primary min-h-[80vh] w-[70%]">
        <div className="flex gap-4 min-h-[40vh] border border-[#D9D9D9] rounded-lg p-4">
          <div className="flex-1 flex flex-col justify-between">
            <span className="text-base">Updated Risk Score</span>
            <div className="flex flex-col items-center gap-4">
              {/* <RiskChart5 /> */}
              <SvgChart5 />
              <span className="text-xs leading-6 text-center font-light">
                The patient&apos;s adherence score has increased from 3/10 to
                5/10 due to new risk factors, indicating a moderate risk and the
                need for closer monitoring.
              </span>
            </div>
          </div>
          <div className="flex-[2]">
            <span className="text-base">New Risk Factors</span>
            <hr className="mb-4 mt-2" />
            <div className="flex flex-col gap-2">
              <Accordion heading="Social Support Network">
                <p className="text-xs p-2 font-light">
                  {NAMESPACES.SOCIAL_MSG}
                </p>
              </Accordion>
              <Accordion heading="Alcohol Use">
                <p className="text-xs p-2 font-light">
                  {NAMESPACES.ALCOHOL_MSG}
                </p>
              </Accordion>
            </div>
          </div>
        </div>

        {/* Old Risk Score Section */}
        <div className="flex gap-4 min-h-[40vh] border border-[#D9D9D9] rounded-lg p-4">
          <div className="flex-1 flex flex-col justify-between  max-h-[30vh]">
            <span className="text-base">Old Risk Score</span>
            <div className="flex items-center justify-center w-full">
              {/* <RiskChart3 /> */}
              <SvgChart3 />
            </div>
          </div>
          <div className="flex-[2] flex flex-col gap-4">
            <div className="removed">
              <span className="text-base">Removed Risk Factor</span>
              <hr className="mb-4 mt-2" />
              <Accordion heading="Access & Use of Technology">
                <p className="text-xs p-2 font-light">
                  {NAMESPACES.TECHNOLOGY_MSG}
                </p>
              </Accordion>
            </div>
            <div className="new">
              <span className="text-base">New Interventions</span>
              <hr className="mb-4 mt-2" />
              <div className="flex flex-col gap-2">
                <Accordion heading="Provide Peer Support">
                  <p className="text-xs p-2 font-light">
                    {NAMESPACES.PEER_MSG}
                  </p>
                </Accordion>
                <Accordion heading="Connect with Social Worker">
                  <p className="text-xs p-2 font-light">
                    {NAMESPACES.SOCIAL_WORKER_MSG}
                  </p>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="right w-[30%]">
        <PatientInformationSidePanel
          header="Patient Information"
          data={patientData}
        />
        <PatientInformationSidePanel
          header="Drug Information"
          data={drugData}
        />
        <CustomButton
          color="primary"
          isFilled={true}
          size="small"
          widthClass="w-fit mt-2"
          onClick={() => {
            setSelectedTabIndex(0)
          }}
        >
          <span>View Full Profile</span>
        </CustomButton>
      </div>
    </div>
  )
}

export default UpdatedAdherence
